// Booking date window and open hours shared by appointment flows.

/** Number of consecutive days shown (today + 6 days ahead). */
export const BOOKING_DAY_COUNT = 7;

/** Sunday open window: 11:15 AM – 6:50 PM (inclusive). */
export const SUNDAY_OPEN_START_MINUTES = 11 * 60 + 15;
export const SUNDAY_OPEN_END_MINUTES = 18 * 60 + 50;

/**
 * Today and the next 6 days (7 total), including Sundays.
 * @param {(date: Date) => string} formatDateLabel - optional DD/MM/YYYY formatter for labels
 */
export function generateBookingDates(formatDateLabel) {
  const dates = [];
  const today = new Date();

  for (let i = 0; i < BOOKING_DAY_COUNT; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const dateString = `${year}-${month}-${day}`;
    const weekday = date.toLocaleDateString('en-US', { weekday: 'short' });
    const formatted = formatDateLabel ? formatDateLabel(date) : dateString;

    dates.push({
      value: dateString,
      label: `${weekday} ${formatted}`,
      disabled: false,
    });
  }

  return dates;
}

export function isSundayDateString(dateStr) {
  if (!dateStr) return false;
  return new Date(`${dateStr}T00:00:00`).getDay() === 0;
}

/** Whether hour:minute (24h) is within open hours for the given day. */
export function isWithinOpenHours(hour24, minute, isSunday) {
  const mins = hour24 * 60 + minute;
  if (isSunday) {
    return mins >= SUNDAY_OPEN_START_MINUTES && mins <= SUNDAY_OPEN_END_MINUTES;
  }
  // Mon–Sat: after 7:00 AM through 6:50 PM
  return mins > 7 * 60 && mins <= SUNDAY_OPEN_END_MINUTES;
}
